import {
  CartItemActionsTranslation,
  CartItemDetailsTranslation,
  CartSummaryTranslation,
  RolesTranslation,
  ShoppingCartItemBasicInfoTranslation,
  ShoppingCartItemPanelTranslation,
  SiteTranslation,
} from './SiteTranslation';
import { ActionMenuTranslation } from '../../app/localization/SiteTranslation';
import baseTranslation from '../../app/localization/nl-nl';

const actionMenuTranslation: ActionMenuTranslation = {
  title: 'Acties',
};

const cartItemActionsTranslation: CartItemActionsTranslation = {
  actionMenu: actionMenuTranslation,
};

const shoppingCartItemBasicInfoTranslation: ShoppingCartItemBasicInfoTranslation = {
  cartItemDetails: {
    configCodeLabel: 'Config. code',
    noItemsLabel: 'Aantal artikelen',
    listPriceLabel: 'Catalogusprijs',
    netPriceLabel: 'Uw nettoprijs',
  },
};

const shoppingCartItemPanelTranslation: ShoppingCartItemPanelTranslation = {
  cartItemActions: cartItemActionsTranslation,
};

const cartSummaryTranslation: CartSummaryTranslation = {
  priceBeforeVatLabel: 'Prijs excl. btw',
  vatLabelFormat: 'Btw ({taxRate}%)',
  priceIncludingVatLabel: 'Prijs incl. btw',
  deliveryFeeLabel: 'Verzendkosten',
  noItemsLabel: 'Aantal artikelen',
  subtotalHeader: 'Subtotaal',
  accordingToAgreementText: 'Volgens overeenkomst',
  surchargesAnnotationText: 'Er kunnen toeslagen van toepassing zijn op de bestelling. Details worden vermeld op de factuur.',
};

const cartItemDetailsTranslation: CartItemDetailsTranslation = {
  configCodeLabel: 'Config. code',
  noItemsLabel: 'Aantal artikelen',
  listPriceLabel: 'Catalogusprijs',
  netPriceLabel: 'Uw nettoprijs',
};

const rolesTranslation: RolesTranslation = {
  admin: 'Beheerder',
  buyer: 'Inkoper',
  flokkSales: 'Flokk Sales',
  flokkSupport: 'Flokk Support',
  flokkDigital: 'Flokk Digital',
  reader: 'Lezer',
};

const translation: SiteTranslation = {
  ...baseTranslation,
  ...{
    b2bHomePage: {
      pageTitleFormat: '',
      pageDescriptionFormat: '',
      onboarding: {
        headerText: 'Welkom',
        welcomeText: 'Fijn dat u er bent. Hieronder vindt u tips om u op weg te helpen.',
        onboardingCards: {
          configureChairTitle: 'Configureer een stoel',
          configureChairText: 'Configureer een stoel',
          placeAnOrderTitle: 'Plaats een bestelling',
          placeAnOrderText: 'Plaats een bestelling',
          manageAndTrackTitle: 'Beheren en volgen',
          manageAndTrackText: 'Beheren en volgen',
          selectAChairTextPart1: 'Kies een stoel in ',
          selectAChairTextPart2: 'Producten',
          selectAChairTextPart3: ' en pas deze in de configurator aan op de wensen van uw klant.',
          addConfigToFavoritesTextPart1: 'U kunt uw configuratie toevoegen aan ',
          addConfigToFavoritesTextPart2: 'Favorieten',
          placeChairToCartTextPart1: 'Is uw stoel klaar om te bestellen? Plaats deze dan in uw ',
          placeChairToCartTextPart2: 'Winkelwagen',
          manageOngoingOrdersTextPart1: 'U kunt lopende bestellingen eenvoudig beheren in ',
          manageOngoingOrdersTextPart2: 'Bestelgeschiedenis',
          manageOngoingOrdersTextPart3: ' en daar ook eerdere bestellingen bekijken.',
          receiveNotificationsFromTrackingText:
            'Via het volgsysteem ontvangt u een melding telkens wanneer de status van de bestelling wijzigt.',
        },
      },
    },
    profilePage: {
      pageTitleFormat: '',
      pageDescriptionFormat: '',
      personalTabTitle: 'Persoonlijk',
      usersTabTitle: 'Gebruikers',
      roles: rolesTranslation,
      personalTabContent: {
        emailLabel: 'E-mail',
        emailNotificationsHeader: 'E-mailmeldingen',
        emailNotifications: {
          orderCreated: 'Bestelling aangemaakt',
          orderStatusChanged: 'Status van bestelling gewijzigd',
          orderCancelled: 'Bestelling geannuleerd',
          orderNotifyOnlyMyOrders: 'Alleen mijn bestellingen',
        },
        firstNameLabel: 'Voornaam',
        lastNameLabel: 'Achternaam',
        phoneNumberLabel: 'Telefoonnummer',
        saveChangesButton: 'Wijzigingen opslaan',
        basicInformationHeader: 'Basisgegevens',
        languageSelectorLabel: 'Taal',
        languages: {
          deDe: 'Duits',
          enGb: 'Engels',
          frFr: 'Frans',
          nlNl: 'Nederlands',
          plPl: 'Pools',
        },
        passwordResetBlock: {
          passwordResetHeader: 'Wachtwoord opnieuw instellen',
          emailSentText: 'We hebben een e-mail gestuurd om uw wachtwoord opnieuw in te stellen. Controleer uw mailbox.',
          sendPasswordResetEmailAgainText: 'E-mail voor wachtwoordherstel opnieuw versturen',
          sendPasswordResetEmailText: 'E-mail voor wachtwoordherstel versturen',
          confirmPasswordResetHeader: 'Wachtwoordherstel bevestigen',
          areYouSureResetPasswordText: 'Weet u zeker dat u uw wachtwoord opnieuw wilt instellen?',
          cancelButton: 'Annuleren',
          yesButton: 'Ja',
        },
      },
      usersTab: {
        removeUserTitle: 'Gebruiker verwijderen',
        inviteNewUserButton: 'Nieuwe gebruiker uitnodigen',
        editRolesLabel: 'Rollen bewerken',
        removeLabel: 'Verwijderen',
        removeContactFromOrganisationTextPart1: 'Weet u zeker dat u ',
        removeContactFromOrganisationTextPart2: ' uit uw organisatie wilt verwijderen?',
        invitationsTable: {
          pendingInvitationsHeader: 'Openstaande uitnodigingen',
          userNameHeader: 'Gebruikersnaam',
          emailHeader: 'E-mail',
          expiresAtHeader: 'Verloopt op',
          contextMenuHeader: '',
          removeLabel: 'Verwijderen',
          actionMenu: actionMenuTranslation,
        },
        usersTable: {
          rolesHeader: 'Rollen',
          userNameHeader: 'Gebruikersnaam',
          contextMenuHeader: '',
          roles: rolesTranslation,
        },
        inviteNewUsersModal: {
          inviteNewUserHeader: 'Nieuwe gebruiker uitnodigen',
          firstNameLabel: 'Voornaam',
          lastNameLabel: 'Achternaam',
          emailLabel: 'E-mail',
          repeatEmailLabel: 'Herhaal e-mail',
          grantedRolesLabel: 'Toegekende rollen',
          sendInvitationButton: 'Uitnodiging versturen',
          roles: rolesTranslation,
        },
        confirmInvitationRemovalModal: {
          areYouSureRemoveInvitationText: 'Weet u zeker dat u de uitnodiging wilt verwijderen voor ',
          title: 'Uitnodiging verwijderen',
        },
        changeUserRolesModal: {
          selectRolesText: 'Selecteer rollen voor',
          title: 'Rollen bewerken',
          roles: rolesTranslation,
        },
        actionMenu: actionMenuTranslation,
      },
    },
    invitationPage: {
      pageTitleFormat: '',
      pageDescriptionFormat: '',
      headerText: 'U bent uitgenodigd voor Flokk HUB!',
      loggedAsText: 'U bent momenteel bij Flokk Hub ingelogd als',
      useCurrentAccountOrCreateNewText:
        'Wilt u het huidige account gebruiken of een nieuw account aanmaken om de uitnodiging te accepteren?',
      useCurrentAccountButton: 'Huidig account gebruiken',
      createNewAccountButton: 'Nieuw account aanmaken',
      fullfillInvitationText:
        'Om de uitnodiging te accepteren, moet u op het volgende scherm inloggen met een bestaand account of u registreren voor een nieuw account.',
      signUpForFlokkHub: 'Registreren voor Flokk Hub',
      haveAccountInformationText: 'Als u al een account bij Flokk Hub heeft, kunt u dat gebruiken',
      logInWithExistingAccountText: 'Inloggen met bestaand account',
      expiredInvitationInformationText:
        'Uw uitnodiging is verlopen. Vraag het Flokk Team om u een nieuwe uitnodiging te sturen',
      invitationLinkNotValidText: 'Uw uitnodigingslink is ongeldig',
      invitationLinkNotValidInformationText:
        'De uitnodiging die u probeert te gebruiken bestaat niet. Controleer of u de link gebruikt die door Flokk is verstuurd.',
      ifProblemStillOccursContactFlokkText: 'Blijft het probleem bestaan? Neem dan contact op met het Flokk Team voor een nieuwe uitnodiging.',
      somethingWrongWithInvitationText: 'Er is iets misgegaan met uw uitnodiging',
      notAbleToProcessRequestText:
        'We kunnen uw verzoek niet verwerken. Probeer het later opnieuw of neem contact op met het Flokk Team.',
    },
    catalogPage: {
      ...baseTranslation.catalogPage,
      exploreAllItems: 'Bekijk alle configuraties',
      familyItemAvailabilityModal: {
        closeButton: 'Sluiten',
        familyItemIsAvailableOnlyForConfiguration:
          'Dit product kan momenteel niet via Flokk Hub worden gekocht. U kunt het wel configureren en aan uw favorieten toevoegen.',
        familyItemIsUnavailable: 'Dit product kan nog niet via Flokk Hub worden geconfigureerd of gekocht.',
      },
      filterBar: {
        ...baseTranslation.catalogPage.filterBar,
        results: 'Productfamilies: {results}',
      }
    },
    cartPage: {
      pageTitleFormat: '',
      pageDescriptionFormat: '',
      orderSummaryText: 'Besteloverzicht',
      goBackButton: 'Terug',
      deliveryAddressText: 'Afleveradres',
      deliveryInstructionsLabel: 'Leveringsinstructies, zichtbaar op het verzendlabel',
      deliveryInstructionsPlaceholder: 'Bijv. tweede verdieping',
      placeOrderButton: 'Bestelling plaatsen',
      cartList: {
        sendByEmailButton: 'Versturen per e-mail',
        placeOrderButton: 'Bestelling plaatsen',
        editProductLabel: 'Product bewerken',
        removeFromCardLabel: 'Verwijderen uit winkelwagen',
        cartOverviewTitle: 'Overzicht winkelwagen',
        cartSummaryTitle: 'Samenvatting winkelwagen',
        downloadImagesLabel: 'Afbeeldingen downloaden',
        noneOrdersSelectedLabel: 'Geen bestellingen geselecteerd',
        continueWithOrdersLabelFormat: 'Doorgaan met {ordersCount} bestellingen',
        placeAllOrdersLabelFormat: 'Alle {ordersCount} bestellingen plaatsen',
        cart: 'Winkelwagen',
        cartSummary: cartSummaryTranslation,
        cartHeader: {
          readyForShippingText: 'Klaar voor verzending binnen {minDays} - {maxDays} werkdagen',
        },
        cartItemList: {
          cartItem: {
            cartItemActions: cartItemActionsTranslation,
            cartItemBodyDetails: {
              removeItemButton: 'Artikel verwijderen',
              updateQuantityButton: 'Aantal bijwerken',
              revertButton: 'Herstellen',
              cartItemDetails: cartItemDetailsTranslation,
            },
          },
        },
      },
      orderSummary: {
        brandLabel: 'Merk',
        noItemsLabel: 'Aantal artikelen',
        readyForShippingFromFactoryLabel: 'Klaar voor verzending vanuit de fabriek',
        readyForShippingFromFactoryValue: '{minDays} - {maxDays} werkdagen',
        customReferenceLabel: 'Uw referentie',
        customReferencePlaceholder: 'Bijv. uw bestelnummer',
        customNameLabel: 'Naam bestelling',
        customNamePlaceholder: 'Bijv. naam van de klant',
        commentLabel: 'Opmerking',
        commentPlaceholder: '',
      },
      deliveryAddress: {
        addButton: 'Nieuw adres invoeren',
        editButton: 'Bewerken',
        deliveryAddressForm: {
          city: {
            name: 'Plaats',
            fieldRequired: 'Plaats is verplicht',
          },
          country: {
            name: 'Land',
          },
          zipCode: {
            name: 'Postcode',
            fieldRequired: 'Postcode is verplicht',
            wrongFormat: 'De ingevoerde waarde is geen geldige postcode',
          },
          addressLine1: {
            name: 'Adresregel 1',
            fieldRequired: 'Adresregel 1 is verplicht',
          },
          addressLine2: {
            name: 'Adresregel 2',
          },
          recipient: {
            name: 'Ontvanger',
            fieldRequired: 'Ontvanger is verplicht',
          }
        },
      },
      cartSummary: cartSummaryTranslation,
      orderCreationConfirmationModal: {
        title: 'Weet u zeker dat u wilt doorgaan?',
        confirmationText: 'U plaatst een bestelling namens',
        confirmButton: 'Bestelling plaatsen',
        cancelButton: 'Annuleren',
      },
      orderCreatedModal: {
        somethingWentWrongTitle: 'Er is iets misgegaan',
        notAllOrdersCreatedSuccessfullyTitle:
          'Er is iets misgegaan. Slechts {succedeedOrdersCount} van ${totalOrdersCount} zijn succesvol aangemaakt',
        technicalIssuesSubtitle: 'Door technische problemen kunnen we geen bestelling aanmaken met de volgende configuraties:',
        orderCreatinFailedSubtitle: 'Het aanmaken van de bestelling is mislukt. Probeer het opnieuw of neem contact op met het Flokk Hub supportteam.',
        notAllOrdersCreatedSuccessfullySubtitle:
          'Succesvol aangemaakte bestellingen: {succedeedOrders}.\nNiet verwerkt: {failedOrders}.\nProbeer het opnieuw of neem contact op met het Flokk Hub supportteam.',
        OrderCreatedSuccessNotification: {
          ongoingOrdersLabel: 'Bekijk lopende bestellingen',
          orderDetailsLabel: 'Bekijk details van de bestelling',
          orderReceivedTitle: 'Bedankt! We hebben uw bestelling ontvangen.',
          orderReceivedSubtitle:
            'U ontvangt een orderbevestiging per e-mail zodra de bestelling in productie gaat.',
        },
      },
      sendCartToEmail: {
        headerText: 'Geselecteerde artikelen per e-mail versturen',
        sendButton: 'Versturen',
        emailLabel: 'E-mail',
      },
    },
    configurationPage: {
      ...baseTranslation.configurationPage,
      priceTaxText: '(EXCL. BTW)',
    },
    configuratorActions: {
      addToCartButton: 'In winkelwagen',
      favoriteButton: {
        addToFavoritesText: 'Toevoegen aan favorieten',
        addingToFavoritesText: 'Toevoegen aan favorieten...',
        addedToFavoritesText: 'Toegevoegd aan favorieten',
        addingToFavoritesFailed: 'Het product kon niet aan favorieten worden toegevoegd. Controleer of het in uw land beschikbaar is.',
      },
      updateCartItemButton: 'Artikel in winkelwagen bijwerken',
      addedToCartModal: {
        updatedInCartHeader: 'Bijgewerkt in winkelwagen',
        addedToCartHeader: 'Toegevoegd aan winkelwagen',
        goToCartButton: 'Naar winkelwagen',

        quantityInfo: {
          productAddedText: '1 product toegevoegd',
          productsAddedText: '{quantityAdded} producten toegevoegd',
        },
        addedToCartItem: {
          cartItemPreview: {
            cartItemDetails: cartItemDetailsTranslation,
          },
          cartItemSubtotal: {
            exclValText: '(excl. btw)',
            subtotalText: 'Subtotaal',
          },
        },
      },
    },
  },
  favoritesPage: {
    title: 'Mijn favorieten',
    downloadImagesLabel: 'Afbeeldingen downloaden',
    editNameLabel: 'Naam bewerken',
    removeLabel: 'Verwijderen',
    searchInputLabel: 'Zoeken naar',
    searchInputPlaceholder: 'Productnaam of configuratiecode',
    sortBySelectLabel: 'Sorteren op',
    sortByNameAscLabel: 'Naam (A-Z)',
    sortByNameDescLabel: 'Naam (Z-A)',
    sortByDateAscLabel: 'Datum toegevoegd (oudste)',
    sortByDateDescLabel: 'Datum toegevoegd (nieuwste)',
    sortByPriceAscLabel: 'Prijs (laag naar hoog)',
    sortByPriceDescLabel: 'Prijs (hoog naar laag)',
    favoriteItem: {
      addToCartButton: 'In winkelwagen',
      showConfigurationButton: 'Configuratie tonen',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    editConfigurationNameModal: {
      header: 'Naam bewerken',
      description: 'Label uw configuratie met de naam van de klant, een datum of een ander kenmerk',
      configurationNameLabel: 'Naam configuratie',
      saveButton: 'Opslaan',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    favoriteItemDetailsModal: {
      configurationText: 'Configuratie',
      accessoriesText: 'Accessoires',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    removalConfirmationModal: {
      header: 'Verwijderen uit favorieten',
      description: 'Weet u zeker dat u dit product uit uw favorieten wilt verwijderen?',
      confirmButton: 'Ja, verwijderen',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    emptyFavoritesList: {
      titleText: 'Uw favorietenlijst is leeg',
      subtitleText: 'maar dat hoeft niet zo te blijven',
      labelText: 'Bekijk producten',
    },
  },
  loginPage: {
    welcomeText: 'Welkom bij Flokk Hub!',
    getStartedButton: 'Aan de slag',
  },
  orderPage: {
    downloadImagesLabel: 'Afbeeldingen downloaden',
    shippingWithinTextFormat: 'Verzending binnen {minDays} - {maxDays} werkdagen',
    shippingSoonText: 'Binnenkort verzonden',
    weHaveDelayText: 'Er is enige vertraging',
    changeInOrderAlertText: 'Er is een wijziging in uw bestelling. De onderstaande informatie kan onjuist zijn.',
    orderActionButtons: {
      yourReferenceLabel: 'Uw referentie',
      orderNameLabel: 'Naam bestelling',
      setOrderNameText: 'Naam bestelling instellen',
      addEntireOrderToCartButton: 'Volledige bestelling in winkelwagen',
    },
    trackingInformation: {
      trackOrderButton: 'Bestelling volgen',
    },
    shippingDate: {
      shippingDateText: 'Verzenddatum',
      shippingTimeText: 'Verzendtermijn',
      withinDaysTextFormat: 'binnen {minDays} - {maxDays} werkdagen',
      soonText: 'Binnenkort',
      delayText: 'Er is enige vertraging',
    },
    orderDetailsPanel: {
      deliveryAddressLabel: 'Afleveradres',
      totalPriceBeforeVatLabel: 'Totaalprijs excl. btw',
      totalPriceIncludingVatLabel: 'Totaalprijs incl. btw',
      buyerLabel: 'Inkoper',
      summaryLabel: 'Samenvatting',
      summary: cartSummaryTranslation,
    },
    orderDetailsProduct: {
      reorderButton: 'Opnieuw bestellen',
      productsHeader: 'Producten',
      shoppingCartItemPanel: shoppingCartItemPanelTranslation,
      shoppingCartItemBasicInfo: shoppingCartItemBasicInfoTranslation,
    },
    orderShipmentsModal: {
      closeButton: 'Sluiten',
      header: 'Deze levering bestaat uit meerdere zendingen',
      orderShipmentPanelHeader: {
        deliveryNumberLabel: 'Levering nr. ',
        shippingDateLabel: 'Verzenddatum: ',
        trackOrderButton: 'Bestelling volgen',
      },
      orderShipmentsList: {
        configurationCodeLabel: 'Config. code',
      },
    },
    editOrderModal: {
      orderTextFormat: 'Bestelling {orderNumber}',
      saveButton: 'Opslaan',
      nameLabel: 'Naam',
    },
    reorderModal: {
      areYouSureText: 'Weet u zeker dat u de inhoud van de bestelling aan de winkelwagen wilt toevoegen?',
      confirmButton: 'Bevestigen',
      orderTextFormat: 'Bestelling {orderNumber}',
    },
  },
  quickOrderPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Snel bestellen',
    title: 'Voer uw configuratiecode in',
    description: 'en wij brengen u naar de configurator',
    codeInputPlaceholder: 'Typ hier de code en druk op Enter',
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Code moet exact 6 tekens zijn, of 6 tekens voorafgegaan door "M-" voor een modulaire configuratie.',
      codeInvalid: 'De opgegeven code {invalidCode} is ongeldig! Controleer of deze correct is ingevoerd.',
      codeNotFound: 'Kan geen productconfiguratie vinden met code {notFoundCode}',
    },
  },
  ordersPage: {
    title: 'Bestelgeschiedenis',
    ongoingOrdersTitle: 'Lopende bestellingen',
    pastOrdersTitle: 'Eerdere bestellingen',
    ordersListFilter: {
      searchLabel: 'Zoeken naar',
      searchPlaceholder: 'Bestelnummer of naam',
      onlyMineLabel: 'Alleen de mijne',
      dateLabel: 'Datum',
      searchButton: 'Zoeken',
      resetButton: 'Wissen',
      sortByLabel: 'Sorteren op',
      sortByOrderNumberAscLabel: 'Bestelnummer (oplopend)',
      sortByOrderNumberDescLabel: 'Bestelnummer (aflopend)',
      sortByOrderDateAscLabel: 'Besteldatum (oplopend)',
      sortByOrderDateDescLabel: 'Besteldatum (aflopend)',
      sortByOrderTotalAscLabel: 'Totaalbedrag (oplopend)',
      sortByOrderTotalDescLabel: 'Totaalbedrag (aflopend)',
    },
    tabContent: {
      noOrdersMatchingCriteriaText: 'Er zijn geen bestellingen die aan uw criteria voldoen.',
      pastOrdersTable: {
        orderNumberHeader: 'Bestelnr.',
        orderNameHeader: 'Naam bestelling',
        orderDateHeader: 'Besteldatum',
        shippingDateHeader: 'Verzenddatum',
        productsHeader: 'Producten',
        totalPriceHeader: 'Totaalprijs',
        buyerHeader: 'Inkoper',
        cancelledText: 'Geannuleerd',
      },
      order: {
        changesInOrderAlertText: 'Er is een wijziging in uw bestelling. De onderstaande informatie kan onjuist zijn.',
        shippingDateFormat: 'Verzenddatum {date}',
        orderHeader: {
          orderNoLabel: 'Bestelnr.',
          orderDateLabel: 'Besteldatum',
          totalPriceLabel: 'Totaalprijs',
          buyerLabel: 'Inkoper',
          orderNameLabel: 'Naam bestelling',
          yourReferenceLabel: 'Uw referentie',
        },
        orderItem: {
          cartItemDetails: cartItemDetailsTranslation,
        },
        shippingMessage: {
          shippingSoonText: 'Binnenkort verzonden',
          shippingWithinDaysFormat: 'Verzending binnen {minDays} - {maxDays} werkdagen',
          weHaveDelayText: 'Er is enige vertraging',
        },
      },
    },
  },
  sideMenu: {
    legacyProductsLabel: 'Producten',
    legacyFavoritesLabel: 'Mijn favorieten',
    pricelistsLabel: 'Producten',
    productsLabel: 'Configureren',
    favoritesLabel: 'Favorieten',
    quickOrderLabel: 'Snel bestellen',
    orderHistoryLabel: 'Bestelgeschiedenis',
    termsLabel: 'Algemene voorwaarden',
    signOutLabel: 'Uitloggen',
  },
  topMenu: {
    cartButton: 'Winkelwagen',
    userInfo: {
      pricingContextFormat: 'Alle prijzen in {currency} (excl. btw)',
      storeSelector: {
        searchPlaceholder: 'Voer naam of ID-nummer in',
        clearSearchButton: 'Zoekopdracht wissen',
        storeChangeFailedWarning: {
          message: 'Helaas kunnen we uw huidige organisatie niet wijzigen naar de gevraagde organisatie. Probeer het opnieuw of neem contact op met de klantenservice.'
        },
        noSearchResultsText: 'Geen overeenkomende klanten gevonden'
      }
    }
  },
  appLoader: {
    loaderText: 'Bezig met initialiseren ...',
  },
};

export default translation;
